import type { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";

/**
 * Stripe.js, for paying in the app. A table's PaymentIntent lives on the host's
 * connected account, so Stripe.js is loaded once per account with the
 * platform's publishable key. Loading adds Stripe's script to the page, so it
 * waits for the first payment; with no key, as in tests, nothing loads.
 */
export class StripePayments {
  readonly #byAccount = new Map<string, Promise<Stripe | null>>();

  constructor(readonly publishableKey: string | null) {}

  forAccount(accountId: string): Promise<Stripe | null> {
    const key = this.publishableKey;
    if (!key) return Promise.resolve(null);
    const known = this.#byAccount.get(accountId);
    if (known) return known;
    const loading = loadStripe(key, { stripeAccount: accountId });
    // A script that failed to load is tried again next time.
    loading.catch(() => this.#byAccount.delete(accountId));
    this.#byAccount.set(accountId, loading);
    return loading;
  }
}
